import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import getLocale from '../../i18n/getLocale';


class SchedulesDuplicate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      name: '',
      aircraft_model: '',
      date_start: '',
      date_finish: '',
      schedule_used_regimes: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.duplicate = this.duplicate.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleRegimeChange(id, event) {
    var data = this.state.schedule_used_regimes;
    data.map(function(dado, index){
      if (data[index].id == id) {
        data[index].start_day_str = event.target.value;
      }
    });
    this.setState({schedule_used_regimes: data});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData(1));
    }
  }

  loadData (first_load) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            aircraft_model: responseJson.data.main.aircraft_model.model,
            date_start: responseJson.data.main.date_start_str,
            date_finish: responseJson.data.main.date_finish_str,
            schedule_used_regimes: responseJson.data.schedule_used_regimes,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal: true});
      });
    });
  }


  // Fetch salvando a edição
  duplicate(event) {
    event.preventDefault();
    this.handleAlert(this.locale.Escalas.DuplicarEscala.aguardeEnquantoAEscalaEDuplicada, 'warning', 'open');
    var datasave = {
      old_id: this.state.id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      schedule_used_regimes: this.state.schedule_used_regimes,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/duplicar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/escala/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Escalas.DuplicarEscala.titulo} - {this.state.aircraft_model} - {this.state.name}</h3>
      <Link to="/escalas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.duplicate}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Escalas.DuplicarEscala.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Escalas.DuplicarEscala.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
            </div>
          </div>
        </div>
        <hr />
        <h3>{this.locale.Escalas.DuplicarEscala.formulario.tituloRegimesDaEscala}</h3>
        <hr/>
        {Object.keys(self.state.schedule_used_regimes).map(function(sp) {
          let period = self.state.schedule_used_regimes[sp];
          return (
            <div>
              <h4>{period.schedule_regime.name}</h4>
              <div className="row">
                <div className="col-md-4 form-group">
                  <label>{self.locale.Escalas.DuplicarEscala.formulario.DataInicial}:</label>
                  <InputMask maskChar={null} mask="99/99/9999" type="text" className="form-control" name="start_day_str" value={period.start_day_str} onChange={self.handleRegimeChange.bind(self, period.id)} required />
                </div>
              </div>
            </div>
          );
        })}
        <hr />
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Escalas.DuplicarEscala.formulario.botaoSalvarDuplicacao}</button>
        </div> 
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default SchedulesDuplicate;


// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulesDuplicate.js